const level = [
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 0,   0,   0,   0,  99,  99,  99,  99,   0,   0],
  [ 0,   0,  99,  99,  99,   0,   0,  99,   0,   0],
  [ 0,   0,  99,   0,   9,  51,   0,  99,   0,   0],
  [ 0,   0,  99,   0,   8,  64,   0,  99,   0,   0],
  [ 0,   0,  99,  52,   0,   0,  99,  99,   0,   0],
  [ 0,   0,  99,  99,  99,  99,  99,   0,   0,   0],
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],

]

export default level